import { romeApi, utils } from "framework";

const state = {
  partnerId: null,
  name: null,
  hideMyPlanConnect: null,
  userId: null,
  options: [],
  agencies: [],
  ready: false,
};

const getters = {};

const actions = {
  async load(context, data) {
      let id = data.partnerId;
      if (!id || context.state.partnerId == id) return;
      var partner = await romeApi.get(`/partner/${id}`);
      context.commit('setPartner', partner);
      context.state.ready = true;
  },
  async update(context, data) {
      let id = context.state.partnerId;
      if (!id) return;
      let postData = _.omit(context.state, "ready");
      _.assign(postData, data);
      await romeApi.post(`/partner/${id}`, postData);
      context.commit("setPartner", data);
  },
};

const mutations = {
  setPartner(state, data) {
      utils.copyCommonProperties(data, state);
  },
  clearPartner(state) {
      utils.resetStoreStateProperties(state);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/partner/x-partner.js